import { twMerge } from 'tailwind-merge';

interface Props {
    value: number;
    max?: number;
    className?: string;
}

/**
 * Div-based progress bar because border-radius is not reliably
 * applied on <progress> pseudo-elements across browsers.
 */
const ProgressBar = ({ value, max = 100, className }: Props) => {
    const ratio = max > 0 ? value / max : 0;
    const percent = Math.min(Math.max(ratio * 100, 0), 100);

    return (
        <div
            role="progressbar"
            aria-valuenow={value}
            aria-valuemin={0}
            aria-valuemax={max}
            className={twMerge('h-6 w-full rounded-sm bg-gray-200', className)}
        >
            <div
                className={twMerge(
                    'bg-main h-full',
                    percent >= 100 ? 'rounded-sm' : 'rounded-s-sm',
                )}
                style={{ width: `${percent}%` }}
            />
        </div>
    );
};

export default ProgressBar;
